import {athubAxios, merge} from '../../util'

import {HeaderBuilder} from '@/util/athub-axios/header'

function mergeConfig(config) {
  return merge(true, {}, HeaderBuilder.getHeadersByLocalStorage(['username', 'realname']), config);
}

export { mergeConfig }

export default class RestResource {

  constructor({server, resource}) {
    this.server = server;
    this.resource = resource;
    this._getAllUrl = [this.server, this.resource].join('/');
    this._addUrl = [this.server, this.resource].join('/');
    this._batchAddUrl = [this.server, this.resource, 'batch'].join('/');
    this._getUrl = [this.server, this.resource, '{id}'].join('/');
    this._updateUrl = [this.server, this.resource, '{id}'].join('/');
    this._deleteUrl = [this.server, this.resource, '{id}'].join('/');
    this._listUrl = [this.server, this.resource, 'list'].join('/');
    this._pageUrl = [this.server, this.resource, 'page'].join('/');
    this._countUrl = [this.server, this.resource, 'count'].join('/');
  }

  getAll (athubConfig) {
    return athubAxios.get(this._getAllUrl, mergeConfig(athubConfig));
  }

  add (model, athubConfig) {
    return athubAxios.postByJson(this._addUrl, model, mergeConfig(athubConfig));
  }

  batchAdd (models, athubConfig) {
    return athubAxios.post(this._batchAddUrl, models, mergeConfig(athubConfig));
  }

  get (id, athubConfig) {
    return athubAxios.get(this._getUrl.replace('{id}', id), mergeConfig(athubConfig));
  }

  update (id, model, athubConfig) {
    return athubAxios.put(this._updateUrl.replace('{id}', id), model, mergeConfig(athubConfig));
  }

  delete (id, athubConfig) {
    return athubAxios.delete(this._deleteUrl.replace('{id}', id), mergeConfig(athubConfig));
  }

  list (search, athubConfig) {
    return athubAxios.postByJson(this._listUrl, search, mergeConfig(athubConfig));
  }

  page (pageSearch, athubConfig) {
    return athubAxios.postByJson(this._pageUrl, pageSearch, mergeConfig(athubConfig));
  }

  count (search, athubConfig) {
    return athubAxios.postByJson(this._countUrl, search, mergeConfig(athubConfig));
  }
}